import { del } from "@/shared/utils/fetchApi";

export async function cleanupProductKnowledgeBase(
  productId: string,
): Promise<{ success: boolean }> {
  await del(`/knowledge-bases/by-product/${productId}/content`);
  return { success: true };
}
